export const NotFoundPage = () => (
  <main id="top" className="as-not-found">
    <span>404</span>
    <h1>Cette route ne mène pas à une voiture.</h1>
    <p>La page a peut-être changé d’adresse. Les guides et la page d’accueil restent disponibles.</p>
    <div>
      <a className="as-button as-button-dark" href="/">Retour à l’accueil</a>
      <a className="as-link" href="/conseils/">Voir les conseils</a>
    </div>
  </main>
);

